/**
 * Calls the entry endpoint.
 *
 * @param {string} apiUrl the API URL. 
 * @param {array} entries the entries ids.
 * @param {string} action the action button action [archive, unarchive].
 * @param {object} $container the table container.
 */
function updateEntry( apiUrl, entries, action, $container ) {
	window.mce = 'mce' in window ? window.mce : {};
	$.ajax({
		url: apiUrl,
		data: {
			action,
			data: entries,
		},
		success: function() {
			$container.trigger( 'tableUpdate', 0 );
		}
	});
}

/**
 * Archives the entry.
 */
export function selectEntriesActions() {
	const tableContainer = document.querySelector( '.m__dashboard-table' );
	if ( !tableContainer ) {
		return;
	}

	window.mce = 'mce' in window ? window.mce : {};

	$( tableContainer ).on( 'onActionButtonClick', function onArchive( event, args ) {
		updateEntry( `${ window.mce.api_url }ime-entry`, args.data, args.action, $( this ) );
	});	
}